import React from 'react'

import CheckBox from 'src/components/CheckBox'
import InputField from 'src/components/InputField'

const Tribute = ({ tribute, show_input_labels }) => tribute.enable_tribute &&
  <div>
    <h2 className="h5 section-heading section-heading-tribute">Tribute</h2>
    {!tribute.hide_recipient_send &&
    <div className="mb-3">
      <CheckBox
        {...tribute.booleanProps('enabled')}
        label="Dedicate this donation in honor or in memory of someone"
      />
    </div>
    }
    {
      (tribute.state.enabled || tribute.hide_recipient_send) &&
      <>
        <InputField
          {...tribute.inputProps('honoree_name')}
          type="text"
          label="Honoree name"
          labelClass={show_input_labels ? 'form-label' : 'visually-hidden'}
          prepend={(() => {
            switch (tribute.tribute_types.length) {
            case 0: return
            case 1: return (
              <span className="input-group-text">
                In {tribute.tribute_types[0]} of
              </span>
            )
            default:
              // extract error for vanilla input
              const { error, ...typeProps } = tribute.inputProps('tribute_type')
              return (
                <select
                  {...typeProps}
                  className="form-select flex-grow-0 w-auto"
                  style={{ fieldSizing: 'content' }}
                >
                  {tribute.tribute_types.map(value =>
                    <option key={value} value={value}>In {value} of</option>
                  )}
                </select>
              )
            }
          })()}
          bs5
        />
        {!tribute.hide_recipient_send &&
        <div className="mb-3">
          <CheckBox
            {...tribute.booleanProps('has_recipient')}
            label="Send a heartfelt message and a certificate with your donation."
            afterLabel={
              <button
                type="button"
                className="btn btn-link p-0 align-baseline"
                data-plg-modal-label="Tribute Examples"
                data-plg-modal-src={tribute.modal?.src}
                data-plg-modal-id={tribute.modal?.id}
                data-plg-modal-max-width="37.5rem"
              >
                See examples
              </button>
            }
            hint="A link to fill this out later will be provided in your donation receipt."
          />
        </div>
        }
        {
          !tribute.hide_recipient_send && tribute.state.has_recipient &&
          <>
            <InputField
              {...tribute.inputProps('given_by')}
              type="text"
              label="Given by"
            />
            <div className="row gx-2">
              <div className="col">
                <InputField
                  {...tribute.inputProps('recipient_name')}
                  type="text"
                  label="Recipient name"
                />
              </div>
              <div className="col">
                <InputField
                  {...tribute.inputProps('recipient_email')}
                  type="email"
                  label="Recipient email"
                />
              </div>
            </div>
            <InputField
              {...tribute.inputProps('recipient_message')}
              type="textarea"
              label="Message to recipient (optional)"
              rows="4"
              hint={
                <span>
                  <span className={
                    tribute.state.recipient_message.length > 2000
                    ? 'text-danger'
                    : null
                  }>
                    {tribute.state.recipient_message.length}
                  </span>/2000 characters
                </span>
              }
            />
          </>
        }
      </>
    }
  </div>

export default Tribute
